import React from 'react';
import './DescItem.scss';

function DescItem({ item }) {
    return (
        <div className="desc-item">
            <div className="label-icon">{item?.icon}</div>
            <div className="desc-content">
                <div className="desc-title">{item?.label}</div>
                <span className="desc-detail">
                    {item.label === 'Phone' || item.label === 'Fax' ? (
                        <a href={`tel:${item.value}`}>{item.value}</a>
                    ) : item.label === 'Email' ? (
                        <a href={`mailto:${item.value}`}>{item.value}</a>
                    ) : (
                        item.value
                    )}
                </span>
            </div>
        </div>
    );
}

export default DescItem;
